module.exports = "/_next/static/images/bgPhone2x-bb1bc16f7dddc8c68074a081343cd0b4.png.webp";